import React, { useState } from 'react';
import { Bell, Mail, MessageSquare, Send, Plus } from 'lucide-react';
export const NotificationManagement = () => {
  const templates = [{
    name: 'Welcome Email',
    type: 'Email',
    icon: Mail,
    active: true,
    subject: "Welcome to AMU - Abuja's Premium Real Estate Marketplace"
  }, {
    name: 'Verification Approved',
    type: 'Email',
    icon: Mail,
    active: true,
    subject: 'Your listing has been verified'
  }, {
    name: 'Inspection Reminder',
    type: 'SMS',
    icon: MessageSquare,
    active: true,
    subject: 'Reminder: Property inspection tomorrow'
  }, {
    name: 'New Message Alert',
    type: 'Push',
    icon: Bell,
    active: false,
    subject: 'You have a new message'
  }];
  const [activeTemplateIndex, setActiveTemplateIndex] = useState(0);
  const activeTemplate = templates[activeTemplateIndex];
  return <div className="space-y-6 animate-in fade-in" data-id="element-816">
      <div className="flex justify-between items-center" data-id="element-817">
        <div data-id="element-818">
          <h1 className="text-2xl font-serif font-bold text-slate-900 dark:text-white mb-1" data-id="element-819">
            Notification Management
          </h1>
          <p className="text-slate-500 dark:text-slate-400" data-id="element-820">
            Manage automated emails, SMS, and push notifications.
          </p>
        </div>
        <button className="px-4 py-2 bg-secondary hover:bg-secondary-dark text-primary-900 font-bold rounded-lg flex items-center gap-2 transition-colors" data-id="element-821">
          <Plus size={18} data-id="element-822" /> New Campaign
        </button>
      </div>

      <div className="grid lg:grid-cols-3 gap-6" data-id="element-823">
        {/* Left Col: Templates List */}
        <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 overflow-hidden h-fit" data-id="element-824">
          <div className="p-4 border-b border-slate-200 dark:border-slate-700 bg-slate-50 dark:bg-slate-800/50" data-id="element-825">
            <h3 className="font-bold text-slate-900 dark:text-white" data-id="element-826">
              Active Templates
            </h3>
          </div>
          <div className="divide-y divide-slate-200 dark:divide-slate-700/50" data-id="element-827">
            {templates.map((tpl, i) => {
            const Icon = tpl.icon;
            const isActive = activeTemplateIndex === i;
            return <div key={i} onClick={() => setActiveTemplateIndex(i)} className={`p-4 cursor-pointer transition-colors flex items-center justify-between ${isActive ? 'bg-slate-100 dark:bg-slate-800' : 'hover:bg-slate-50 dark:hover:bg-slate-800/50'}`} data-id="element-828">
                  <div className="flex items-center gap-3" data-id="element-829">
                    <div className="p-2 bg-white dark:bg-slate-700 rounded-lg text-slate-700 dark:text-slate-300 border border-slate-200 dark:border-transparent" data-id="element-830">
                      <Icon size={16} data-id="element-831" />
                    </div>
                    <div data-id="element-832">
                      <h4 className={`font-bold text-sm ${isActive ? 'text-slate-900 dark:text-white' : 'text-slate-700 dark:text-slate-300'}`} data-id="element-833">
                        {tpl.name}
                      </h4>
                      <p className="text-xs text-slate-500" data-id="element-834">{tpl.type}</p>
                    </div>
                  </div>
                  <div className={`w-2 h-2 rounded-full ${tpl.active ? 'bg-emerald-500 dark:bg-emerald-400' : 'bg-slate-300 dark:bg-slate-600'}`} data-id="element-835"></div>
                </div>;
          })}
          </div>
        </div>

        {/* Right Col: Editor */}
        <div className="lg:col-span-2 space-y-6" data-id="element-836">
          <div className="bg-white dark:bg-[#1e293b] rounded-2xl border border-slate-200 dark:border-slate-700 p-6" data-id="element-837">
            <div className="flex justify-between items-center mb-6" data-id="element-838">
              <h2 className="text-lg font-bold text-slate-900 dark:text-white" data-id="element-839">
                Edit Template: {activeTemplate.name}
              </h2>
              <div className="flex items-center gap-2" data-id="element-840">
                <span className="text-sm text-slate-500 dark:text-slate-400" data-id="element-841">
                  Status:
                </span>
                <span className={`px-2 py-1 text-xs font-bold rounded uppercase ${activeTemplate.active ? 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400' : 'bg-slate-100 text-slate-600 dark:bg-slate-700 dark:text-slate-300'}`} data-id="element-842">
                  {activeTemplate.active ? 'Active' : 'Inactive'}
                </span>
              </div>
            </div>

            <div className="space-y-6" data-id="element-843">
              <div data-id="element-844">
                <label className="block text-sm font-bold text-slate-700 dark:text-slate-300 mb-2" data-id="element-845">
                  Subject Line
                </label>
                <input key={activeTemplateIndex} type="text" defaultValue={activeTemplate.subject} className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none" data-id="element-846" />
              </div>

              <div data-id="element-847">
                <div className="flex justify-between items-end mb-2" data-id="element-848">
                  <label className="block text-sm font-bold text-slate-700 dark:text-slate-300" data-id="element-849">
                    Email Body
                  </label>
                  <span className="text-xs text-slate-500" data-id="element-850">
                    Available variables: {'{{user_name}}'}, {'{{login_url}}'}
                  </span>
                </div>
                <textarea rows={8} defaultValue="Hi {{user_name}},\n\nWelcome to AMU! We're thrilled to have you join our community of verified buyers and sellers in Abuja.\n\nTo get started, you can explore our verified listings or set up your profile.\n\nBest,\nThe AMU Team" className="w-full px-4 py-3 rounded-xl bg-white dark:bg-slate-800 border border-slate-300 dark:border-slate-600 text-slate-900 dark:text-white focus:ring-2 focus:ring-secondary outline-none resize-none font-mono text-sm" data-id="element-851" />
              </div>

              <div className="flex justify-end gap-3 pt-4 border-t border-slate-200 dark:border-slate-700" data-id="element-852">
                <button className="px-6 py-2 bg-slate-100 dark:bg-slate-800 text-slate-900 dark:text-white font-bold rounded-xl hover:bg-slate-200 dark:hover:bg-slate-700 transition-colors border border-slate-200 dark:border-transparent" data-id="element-853">
                  Send Test
                </button>
                <button className="px-6 py-2 bg-secondary hover:bg-secondary-dark text-primary-900 font-bold rounded-xl flex items-center gap-2 transition-colors" data-id="element-854">
                  <Send size={18} data-id="element-855" /> Save Template
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>;
};